export default function getIconWidth(size) {
  if (size === 'large') return 18;
  if (size === 'medium') return 16;
  return 12;
}